import axios from "axios"

const getBodyFormData = ({
  articulosId,
  categoriasId,
  nombre,
  imageFile,
}: $TSMigrationFixMe) => {
  const bodyFormData = new FormData()
  bodyFormData.append("nombre", nombre)

  articulosId.forEach((articuloId: $TSMigrationFixMe) => {
    bodyFormData.append("articulosId", articuloId)
  })
  categoriasId.forEach((categoriaId: $TSMigrationFixMe) => {
    bodyFormData.append("categoriasId", categoriaId)
  })

  if (imageFile) {
    bodyFormData.append("FileAsFormFile", imageFile)
  }

  return bodyFormData
}

const CatalogoService = {
  post({
    articulosId = [],
    categoriasId = [],
    imageFile = null,
    nombre,
  }: $TSMigrationFixMe) {
    const bodyFormData = getBodyFormData({
      articulosId,
      categoriasId,
      nombre,
      imageFile,
    })

    return axios({
      method: "post",
      url: `/Catalogo`,
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" },
    })
  },

  update({
    id,
    nombre,
    articulosId = [],
    categoriasId = [],
    imageFile = null,
    ficheroId = null,
  }: $TSMigrationFixMe) {
    const bodyFormData = getBodyFormData({
      articulosId,
      categoriasId,
      nombre,
      imageFile,
    })

    bodyFormData.append("id", id)

    if (!imageFile && ficheroId) {
      bodyFormData.append("FicheroId", ficheroId)
    }

    return axios({
      method: "put",
      url: `/Catalogo`,
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" },
    })
  },

  get({ nombre = "" }) {
    const nombreParam = nombre ? `?Nombre${nombre}` : ""
    return axios.get(`/Catalogo/by-filters${nombreParam}`)
  },

  getById(id: $TSMigrationFixMe) {
    return axios.get(`/Catalogo/${id}`)
  },

  deleteById(id: $TSMigrationFixMe) {
    return axios.delete(`/Catalogo/${id}`)
  },

  share({ emails, catalogoId }: $TSMigrationFixMe) {
    const emailsParam = emails.length
      ? `?${emails
          .filter((email: $TSMigrationFixMe) => email !== "")
          .map((email: $TSMigrationFixMe) => `emails=${email}`).join`&`}`
      : ""
    return axios.post(`/Catalogo/${catalogoId}/shared${emailsParam}`, {})
  },

  getByIdEncrypted(idEncrypted: $TSMigrationFixMe) {
    return axios.get("/Catalogo/by-id-encrypted", {
      params: {
        idEncrypted,
      },
    })
  },
}

export default CatalogoService
